import React from 'react';

type FieldLabelRowProps = {
  label?: React.ReactNode;
  logo?: string;
  dataUp?: string;
  isMissing?: boolean;
  className?: string;
};

/** 16x16 end-of-label target. Userpilot skips 0/1px and aria-hidden nodes. */
export function UserpilotHook({ dataUp }: { dataUp?: string }) {
  if (!dataUp) return null;
  return <div data-up={dataUp} className="userpilot-label-hook" />;
}

/**
 * Label text + app logos + a visible Userpilot target after the sentence.
 * data-up must stay on a sized DIV — a 1px span inside FormLabel makes
 * Userpilot skip it (badge lands mid-text or on the first option).
 */
export function FieldLabelRow({ label, logo, dataUp, isMissing, className }: FieldLabelRowProps) {
  if (!label && !logo && !dataUp) return null;
  return (
    <div
      className={`label-14px userpilot-field-label pb-1 ${className ?? ''}`.trim()}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 1.25,
        color: '#374151',
        backgroundColor: isMissing ? '#FFEBEB' : undefined,
      }}
    >
      {label ? <span style={{ lineHeight: 1.25 }}>{label}</span> : null}
      {logo ? <span className={logo} /> : null}
      <UserpilotHook dataUp={dataUp} />
    </div>
  );
}
